import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const AdminTemplates = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [removing, setRemoving] = useState(null);

  const token = localStorage.getItem("token");

  // 🔒 Templates protegidos
  const PROTECTED_TEMPLATES = ["FlorestaGeneral", "Floresta"];

  const fetchTemplates = async () => {
    try {
      const res = await axios.get("/templates", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const normalized = (res.data || []).map((tpl) =>
        typeof tpl === "string" ? tpl : tpl.name
      );

      setTemplates(normalized);
    } catch (error) {
      console.error("Error cargando templates:", error);
      Swal.fire("Error", "No se pudieron cargar los templates", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const handleDelete = async (name) => {
    // 🔒 Bloqueo extra por seguridad
    if (PROTECTED_TEMPLATES.includes(name)) {
      Swal.fire(
        "No permitido",
        "Este template está reservado para la base de datos",
        "warning"
      );
      return;
    }

    const confirm = await Swal.fire({
      title: "¿Eliminar template?",
      text: `Vas a eliminar: ${name}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      cancelButtonText: "Cancelar",
    });

    if (!confirm.isConfirmed) return;

    try {
      setRemoving(name);

      await axios.delete(`/templates/${name}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTimeout(() => {
        setTemplates((prev) => prev.filter((tpl) => tpl !== name));
        setRemoving(null);
      }, 300);

      Swal.fire("Eliminado", "Template eliminado correctamente", "success");
    } catch (error) {
      console.error("Error eliminando:", error);
      Swal.fire("Error", "No se pudo eliminar", "error");
      setRemoving(null);
    }
  };

  return (
    <div className="p-4 md:p-6 text-white max-w-3xl mx-auto mt-[210px] md:mt-[220px]">
      <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center">
        Templates
      </h2>

      {loading ? (
        <p className="text-center">Cargando...</p>
      ) : templates.length === 0 ? (
        <p className="text-center">No hay templates</p>
      ) : (
        <div className="grid gap-4">
          {templates.map((tpl, index) => {
            const isProtected = PROTECTED_TEMPLATES.includes(tpl);

            return (
              <div
                key={index}
                className={`
                  flex flex-col md:flex-row md:justify-between md:items-center items-center
                  gap-3 bg-[#608CC4] p-4 rounded-lg shadow-md
                  transition-all duration-300
                  ${
                    removing === tpl
                      ? "opacity-0 scale-95"
                      : "opacity-100 scale-100"
                  }
                `}
              >
                {/* Nombre */}
                <span className="text-lg font-semibold break-words text-center md:text-left">
                  {tpl}
                </span>

                {/* Botón o estado protegido */}
                {!isProtected ? (
                  <button
                    onClick={() => handleDelete(tpl)}
                    disabled={removing === tpl}
                    className="
                      secondary px-4 py-2 rounded text-white
                      w-full md:w-auto text-center
                      transition-all duration-200
                      hover:scale-105 active:scale-95
                      disabled:opacity-50
                    "
                  >
                    Eliminar
                  </button>
                ) : (
                  <span className="text-sm italic opacity-80 text-center">
                  No se puede eliminar
                  </span>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AdminTemplates;
